import Joi from '@ads/front-core/utils/joi'

export interface IForm {
  message: string
}

export const joiSchema = Joi.object<IForm>({
  message: Joi.textField().required(),
})
